import { Node } from '@tiptap/core'

/**
 * Node customizado para preservar tabelas completas
 * Mantém toda a estrutura HTML da tabela (tr, td, classes, etc.)
 */
export const CustomTableNode = Node.create({
    name: 'customTable',
    group: 'block',
    atom: true,

    addAttributes() {
        return {
            htmlContent: {
                default: '',
                parseHTML: element => element.outerHTML,
                renderHTML: () => ({}),
            },
        }
    },

    parseHTML() {
        return [{
            tag: 'table',
            getAttrs: element => ({
                htmlContent: element.outerHTML,
            }),
        }];
    },

    renderHTML({ node }) {
        // Sempre usa a nodeView para renderizar tabelas complexas
        return ['div', {}, 0];
    },

    addNodeView() {
        return ({ node }) => {
            const dom = document.createElement('div');
            dom.innerHTML = node.attrs.htmlContent || '';

            return {
                dom,
                contentDOM: null,
            };
        };
    },
});